import { Injectable, inject } from "@angular/core";
import { SupabaseService } from "./supabase.service";
import { CampaignResponse } from "../models/campaign.model";
@Injectable({ providedIn: "root" })
export class CampaignsService {
  private readonly supabase = inject(SupabaseService);
  async load(options: {
    id?: string;
    search?: string;
    page?: number;
  }): Promise<CampaignResponse> {
    const { data, error } =
      await this.supabase.instance.functions.invoke<CampaignResponse>(
        "client-campaigns",
        { body: options },
      );
    if (error || !data?.success)
      throw new Error(
        "No se pudieron cargar las campañas. Inténtalo nuevamente.",
      );
    return data;
  }
}
